"use client";

import { Column } from "@tanstack/react-table";
import {
  Button,
  Input,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "visuais";
import { Filter, EyeOff, ChevronDown } from "lucide-react";
import { ColunaOrdenacao, ColunaDataFiltro } from "@FN";

interface HeaderComFiltroProps {
  column: Column<any>;
  label: string;
  placeholder: string;
  width?: string;
}

export function HeaderComFiltro({
  column,
  label,
  placeholder,
  width = "w-48",
}: HeaderComFiltroProps) {
  const filterValue = column.getFilterValue() as string;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-8 px-2">
          {label}
          <ChevronDown className="ml-2 size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className={width}>
        <ColunaOrdenacao column={column} />

        <DropdownMenuSeparator />
        <div className="px-2 py-2">
          <div className="flex items-center gap-2 mb-2">
            <Filter className="h-3 w-3" />
            <span className="text-xs font-medium">
              Filtrar {label.toLowerCase()}...
            </span>
            {filterValue && <span className="text-blue-600 text-xs">✓</span>}
          </div>
          <Input
            placeholder={placeholder}
            value={filterValue ?? ""}
            onChange={(e) => column.setFilterValue(e.target.value)}
            className="h-7 text-xs"
            onClick={(e) => e.stopPropagation()}
          />
          {filterValue && (
            <Button
              variant="outline"
              size="sm"
              onClick={(e) => {
                e.stopPropagation();
                column.setFilterValue("");
              }}
              className="h-6 w-full text-xs mt-1"
            >
              Limpar filtro
            </Button>
          )}
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => column.toggleVisibility(false)}
          className="flex items-center gap-2"
        >
          <EyeOff className="h-3 w-3" />
          Ocultar Coluna
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

interface HeaderComFiltroDataProps {
  column: Column<any>;
  label: string;
  accessorKey: string;
  width?: string;
}

export function HeaderComFiltroData({
  column,
  label,
  accessorKey,
  width = "w-64",
}: HeaderComFiltroDataProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-8 px-2">
          {label}
          <ChevronDown className="ml-2 size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className={width}>
        <ColunaOrdenacao column={column} />
        <ColunaDataFiltro
          column={column}
          accessorKey={accessorKey}
          label={label}
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
